import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const Modal = forwardRef(({ isOpen, onClose, title, subtitle, footer, className = '', icon = null, ...props }, ref) => {
  if (!isOpen) return null

  const handleBackdropClick = e => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <div
      className="fixed top-0 left-0 right-0 bottom-0 z-1000 flex items-center justify-center bg-black/50"
      onClick={handleBackdropClick}
    >
      <div
        ref={ref}
        className={clsx(
          'bg-white rounded-lg shadow-xl w-full max-w-lg transform transition-all duration-200 outline-none',
          className
        )}
        onClick={e => e.stopPropagation()}
        {...props}
      >
        {title && (
          <header className="p-4 border-b border-border flex justify-between items-center">
            <div>
              <h3 className="m-0 text-xl font-semibold text-dark">{title}</h3>
              <h6 className="m-0 text-base text-gray-700">{subtitle}</h6>
            </div>
            <div onClick={onClose}>{icon}</div>
          </header>
        )}
        <div className="p-4 flex-1">{props.children}</div>
        {footer && <footer className="p-5 border-t border-border text-right">{footer}</footer>}
      </div>
    </div>
  )
})

Modal.displayName = 'Modal'

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  footer: PropTypes.node,
  className: PropTypes.string,
  props: PropTypes.object,
  children: PropTypes.node,
  icon: PropTypes.node,
}

export default Modal
